import {
  MarkingCompleted,
  MarkCompletedSuccess,
  MarkCompletedError,
} from './types'

export const markingCourseCompleted = (): MarkingCompleted => ({
  type: 'training-course/MARKING_COMPLETED',
})

export const markCourseCompletedSuccess = (): MarkCompletedSuccess => ({
  type: 'training-course/MARK_COMPLETED_SUCCESS',
})

export const markCourseCompletedError = (
  error: string
): MarkCompletedError => ({
  error,
  type: 'training-course/MARK_COMPLETED_ERROR',
})
